import {documentation} from "../../data/documentation";
import "./DocumentationPage.css";


const DocumentationPage = () => {

return (

<section className="documentation-page">

<div className="documentation-hero">

<span>Resources</span>

<h1>
Magyne Documentation
</h1>

<p>
Everything you need to configure, use and manage
your Magyne solutions.
</p>

</div>


<div className="documentation-grid">

{
documentation.map((item)=> (

<div className="documentation-card"
key={item.title}>

<h2>
{item.title}
</h2>

<p>
{item.description}
</p>


<ul>

{
item.links.map(link=>(
<li key={link}>
{link}
</li>
))
}

</ul>


</div>

))
}

</div>


</section>

);

};


export default DocumentationPage;